import store from "@/store";
import {isEmpty} from "@/util/Helpers";

export function tableVisibility(fields) {
    return fields.filter(s => {
        if (Object.prototype.hasOwnProperty.call(s, 'visible')) {
            if (s.visible !== false) {
                return s
            }
        } else {
            return s
        }
    })
}

export function transformSelectOptions(data, text, emptyText) {
    let factoriesSelectList = []
    let defaultText = 'Επιλέξτε τιμή..'
    if (!isEmpty(data)) {
        factoriesSelectList.push({
            value: null,
            text: emptyText !== undefined ? emptyText : defaultText,
            defaultText: true
        })
        data.forEach((factory) => {
            if ((Object.prototype.hasOwnProperty.call(factory, 'isActive') && factory.isActive)
                || !Object.prototype.hasOwnProperty.call(factory, 'isActive')) {
                let selectListOption = {
                    value: factory,
                    text: factory[text],
                    defaultText: false
                }
                factoriesSelectList.push(selectListOption)
            }
        })
    }
    return factoriesSelectList
}

export const toggleBusy = async (isBusy) => {
    if (store.getters['isBusy'] !== isBusy) {
        await store.dispatch("isBusy", isBusy);
    }
}


export const makeToast = (instance, message, variant, title) => {
    instance.$bvToast.toast(message, {
        title: !isEmpty(title) ? title : 'Σφάλμα οθόνης',
        variant: variant,
        solid: true,
        toaster: 'b-toaster-top-center',
        appendToast: true
    })
}

export const alertModal = (instance, message, options, type, id) => {
    if (type === 'msgBoxOk' || type === 'msgBoxConfirm') {
        if (isEmpty(options)) {
            options = {
                size: "md",
                buttonSize: 'md',
                headerClass: 'p-2 border-bottom-2 border-bottom  border-light',
                footerClass: 'p-2 border-top-2 border-top  border-light',
                cancelTitle: 'Όχι',
                okTitle: 'Ναι',
                cancelVariant: 'danger',
                okVariant: 'success',
                contentClass: 'text-dark font-weight-bolder',
            }
        }
        if (isEmpty(message)) {

            message = 'Κάτι πήγε στραβά. Παρακαλώ προσπαθήστε ξανά. Αν το πρόβλημα συνεχιστεί, παρακαλώ επικοινωνήστε με το αρμόδιο τμήμα. '
        }
        const h = instance.$createElement
        const titleVNode = h('div', {class: ['text-white'], domProps: {innerHTML: options.title}})
        const contentVNode = h('div', {domProps: {innerHTML: message}})
        return instance.$bvModal[type]([contentVNode], {
            id: id ? id : "modal-id",
            title:  options.title ? [titleVNode] : null,
            size: options.size,
            buttonSize: options.buttonSize,
            headerClass: options.headerClass,
            footerClass: options.footerClass,
            cancelTitle: options.cancelTitle,
            okTitle: options.okTitle,
            cancelVariant: options.cancelVariant,
            okVariant: options.okVariant,
            contentClass: options.contentClass,
            centered: true
        })
    } else {
        return null
    }
}

export const deleteItemByIndex = (items, index) => {
    Object.assign(items[index], null)
    items.splice(index, 1)
    return items
}

export const updateItemByIndex = (items, index, data) => {
    Object.assign(items[index], data)
    items.splice(index, 1, data)
    return items
}
